import React, { useMemo } from 'react';
import { FilePlatePreviewIconWrapper } from './FilePlateStyled';
//@ts-ignore
import { Loader } from '@front/ui-uchi';
import { Space } from '@gr-monorepo/common/ui';
import { getIconByExt } from './MimeIconsLoader';

export const FilePlatePreviewIcon = (props: { isLoading?: boolean; filename: string }) => {
  const Icon = useMemo(() => getIconByExt(props.filename), [props.filename]);
  return (
    <FilePlatePreviewIconWrapper>
      {props.isLoading && (
        <>
          <Space size={24} axis={'vertical'} />
          <Loader color={'#ABE7CE'} size="1rem" />
        </>
      )}
      {!props.isLoading && (
        <>
          <Space size={16} axis={'vertical'} />
          <Icon />
        </>
      )}
    </FilePlatePreviewIconWrapper>
  );
};
